import React from 'react';

// Small round status icon shown to the right of a tab title (rule §Detail.3).
// Green once the tab's checklist step is completed, grey otherwise — the same
// colour logic the list uses for its checklist cells (see the list's CheckMark).
//
// Tabs with no checklist step (Requirement / Supporting Document) simply don't
// render a dot — pass no `done` / omit the component for those.
const StatusDot = ({ done, label }) => (
  <i
    className={`ri-checkbox-circle-fill ms-1 fs-14 text-${
      done ? 'success' : 'secondary'
    }`}
    title={
      label
        ? `${label}: ${done ? 'Completed' : 'Not completed'}`
        : done
          ? 'Completed'
          : 'Not completed'
    }
    aria-hidden='true'
  ></i>
);

export default StatusDot;
